/** @jsx jsx */
import { jsx } from "theme-ui"
import { Link } from "gatsby"
import { RiHeart2Line } from "react-icons/ri"

const Footer = () => (
  <footer
    className="site-footer"
    sx={{
      bg: "background",
    }}
  >
    <div className="container">
      <p>
        @Hameedah Abdullateef 2021. All Rights Reserved{" "}
        <span className="icon -love">
          <RiHeart2Line />
        </span>{" "}
        by <Link to="/">pejudal.com</Link>
      </p>
    </div>
  </footer>
)

export default Footer
